// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.0.20
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * A summary of execution results. It includes counts for standard system statuses (unexecuted, passed, failed, skipped, blocked) which are always present. It can also include counts for any number of user-defined statuses. All statuses are represented as key-value pairs where the key is the status name (string) and the value is the count (number). 
 * @export
 * @interface ResultSummary
 */
export interface ResultSummary {
  [key: string]: number | any;
  /**
   * 
   * @type {number}
   * @memberof ResultSummary
   */
  unexecuted: number;
  /**
   * 
   * @type {number}
   * @memberof ResultSummary
   */
  passed: number;
  /**
   * 
   * @type {number}
   * @memberof ResultSummary
   */
  failed: number;
  /**
   * 
   * @type {number}
   * @memberof ResultSummary
   */
  skipped: number;
  /**
   * 
   * @type {number}
   * @memberof ResultSummary
   */
  blocked: number;
}

export function ResultSummaryFromJSON(json: any): ResultSummary {
  //console.log('ResultSummaryFromJSON', json);
  // look for any other keys besides the standard ones
  const otherKeys = Object.keys(json).filter(key => !(['unexecuted', 'passed', 'failed', 'skipped', 'blocked'].indexOf(key) > -1));
  let returnJson = {
    'unexecuted': json['unexecuted'],
    'passed': json['passed'],
    'failed': json['failed'],
    'skipped': json['skipped'],
    'blocked': json['blocked'],
  };
  if (otherKeys.length > 0) {
    otherKeys.forEach(key => {
      returnJson[key] = json[key];
    });
  }

  return returnJson
}

export function ResultSummaryToJSON(value?: ResultSummary): any {
  if (value === undefined) {
    return undefined;
  }
  let otherKeys = Object.keys(value).filter(key => !(['unexecuted', 'passed', 'failed', 'skipped', 'blocked'].indexOf(key) > -1));
  let returnJSON = {
    'unexecuted': value.unexecuted,
    'passed': value.passed,
    'failed': value.failed,
    'skipped': value.skipped,
    'blocked': value.blocked,
  };
  if (otherKeys.length > 0) {
    otherKeys.forEach(key => {
      returnJSON[key] = value[key];
    });
  }

  //console.log('ResultSummaryToJSON', value);
  return returnJSON
}
